var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3 11h6c.55 0 1-.45 1-1V5.5c0-.55-.45-1-1-1H4.5v-1C4.5 2.675 5.175 2 6 2s1.5.675 1.5 1.5h1a2.5 2.5 0 0 0-5 0v1H3c-.55 0-1 .45-1 1V10c0 .55.45 1 1 1m0-5.5h6V10H6.5V8.86c.295-.175.5-.495.5-.86 0-.55-.45-1-1-1s-1 .45-1 1a1 1 0 0 0 .5.86V10H3z"
})));
export default SvgLock;